import api from "./httpService";

export type SalaryQueryParams = {
    coachId?: string;
    startDate?: string;
    endDate?: string;
};

export type CommissionDetail = {
    packageId: string;
    packageName: string;
    percentage: number;
    sessionsCount: number;
    revenueBasis: number;
    commissionAmount: number;
};

export type SessionSalaryDetail = {
    ratePerSession: number;
    packageSessionsCount: number;
    payPerUseSessionsCount: number;
    paidPayPerUseSessionsCount: number;
    unpaidPayPerUseSessionsCount: number;
    payPerUseRevenue: number;
    paidPayPerUseRevenue: number;
    outstandingPayPerUseRevenue: number;
    packageCoachPay: number;
    payPerUseCoachPay: number;
};

export type SubscriptionCommissionDetail = {
    subscriptionId: string;
    memberName: string;
    packageId: string | null;
    packageName: string;
    subscriptionDate: string;
    subscriptionPrice: number;
    activityName: string;
    allocationPercentage: number;
    allocatedAmount: number;
    commissionPercentage: number;
    commissionAmount: number;
};

export type SalaryRow = {
    coachId: string;
    coachName: string;
    salaryType: "fixed" | "hourly" | "percentage";
    salaryCalculationMode: "single" | "combined";
    enabledComponents: {
        fixed: boolean;
        hourly: boolean;
        percentage: boolean;
        session: boolean;
    };
    fixedSalary: number;
    salaryFixedEnabled: boolean;
    hourlyRate: number;
    salaryHourlyEnabled: boolean;
    commissionPercentage: number;
    salaryPercentageEnabled: boolean;
    sessionDurationHours: number;
    sessionRate: number;
    salarySessionEnabled: boolean;
    commissionDetails: CommissionDetail[];
    subscriptionCommissionDetails: SubscriptionCommissionDetail[];
    ptCommission: number;
    subscriptionCommission: number;
    subscriptionRevenueBasis: number;
    sessionDetails: SessionSalaryDetail;
    sessionsCount: number;
    payableHours: number;
    sessionRevenue: number;
    salaryComponents: {
        fixed: number;
        hourly: number;
        percentage: number;
        session: number;
    };
    salary: number;
    payment: SalaryPayment | null;
};

export type SalaryPayment = {
    expenseId: string;
    amount: number;
    paidAt: string;
    periodStart: string;
    periodEnd: string;
    salaryBreakdown: {
        fixed?: number;
        hourly?: number;
        percentage?: number;
        session?: number;
    };
};

export type SalaryTotals = {
    sessionsCount: number;
    payableHours: number;
    sessionRevenue: number;
    subscriptionRevenueBasis: number;
    salary: number;
    paidSalary: number;
    outstandingSalary: number;
};

export type SalaryResponse = {
    rows: SalaryRow[];
    totals: SalaryTotals;
};

export const getSalaryReport = async (params?: SalaryQueryParams): Promise<SalaryResponse> => {
    const query = new URLSearchParams();

    if (params?.coachId) query.set("coachId", params.coachId);
    if (params?.startDate) query.set("startDate", params.startDate);
    if (params?.endDate) query.set("endDate", params.endDate);

    const response = await api.get(`/salary${query.toString() ? `?${query.toString()}` : ""}`);
    return response.data;
};

export const markSalaryPaid = async (payload: {
    coachId: string;
    startDate: string;
    endDate: string;
    paymentDate: string;
}) => {
    const response = await api.post('/salary/pay', payload);
    return response.data;
};
